export function collectClauses(): HTMLElement[] {
  return Array.from(document.querySelectorAll('section[id]'));
}
